/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .factory('LongPollingService', longPollingService);

  longPollingService.$inject = [
    'NotificationsResource',
    '$timeout'
  ];

  /* jscs:disable disallowFunctionDeclarations*/
  function longPollingService(notificationResource, $timeout){
    var configuration = {
      interval: 5000,
      method: 'FindJob',
      params: []
    };

    var service = {
      params: _setParams,
      start: _start,
      stop: _stop
    };

    return service;

    function _setParams(params){
      configuration.params = params || [];

      return service;
    }

    function _start(callback){
      configuration.stop = false;
      configuration.callback = callback;

      _init();
    }

    function _stop(){
      configuration.stop = true;

      return service;
    }

    /** @private */
    function _init(){
      if(configuration.stop){
        return;
      }

      notificationResource.executeRpc({method: configuration.method, params: configuration.params})
        .$promise
        .then(_success)
        .catch(_fail);

      $timeout(_init, configuration.interval);
    }

    /** @private */
    function _success(data){
      configuration.callback('', data.result);
    }

    /** @private */
    function _fail(error){
      configuration.callback(error);
    }
  }
})();
